import { isNotNull } from '@/modules/cms/helpers/isNotNull.ts';
import {
  type CMSExplorePageResponse,
  type CMSExplorePage,
  type CMSExplorePageBubbleNavItem,
} from '@/modules/cms/types.ts';

export function transformCMSExplorePageResponse(
  response: CMSExplorePageResponse
): CMSExplorePage {
  const [unmodifiedData] =
    response.data.webExplorePageResultsCollection.items.filter(isNotNull);
  const data = { ...unmodifiedData };

  if (
    unmodifiedData?.headerModule?.itemsCollection?.items?.length &&
    data.headerModule?.itemsCollection?.items?.length
  ) {
    data.headerModule.itemsCollection.items =
      unmodifiedData.headerModule.itemsCollection.items.map(
        (item: CMSExplorePageBubbleNavItem) => ({
          title: item.title,
          image: item.image,
          url: item.url,
        })
      ) || [];
  }
  return data;
}
